import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import axios from "axios";
import "@/App.css";

// Components
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import StickyCTA from "@/components/StickyCTA";

// Pages
import Home from "@/pages/Home";
import Programs from "@/pages/Programs";
import Offerings from "@/pages/Offerings";
import About from "@/pages/About";
import Contact from "@/pages/Contact";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

// Scroll to Top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// Layout Wrapper
function AppLayout({ children }) {
  // Setup Lenis Smooth Momentum Scrolling globally
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: "vertical",
      gestureOrientation: "vertical",
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 2,
      infinite: false,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-[#050505] text-[#F6F4EE]">
      <Header />
      <div className="flex-grow">
        {children}
      </div>
      <Footer />
      <StickyCTA />
    </div>
  );
}

function App() {
  // Test backend connection on load (if backend exists)
  useEffect(() => {
    const testBackend = async () => {
      try {
        const response = await axios.get(`${API}/`);
        console.log("Backend Connection Success:", response.data.message);
      } catch (e) {
        console.warn("Backend server not responding. Continuing with standalone client mode.");
      }
    };
    testBackend();
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <AppLayout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/programs" element={<Programs />} />
          <Route path="/offerings" element={<Offerings />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </AppLayout>
    </BrowserRouter>
  );
}

export default App;
